import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = [
    ]
    DEVICE_TYPES = [];
    SIGNAL_FORMATS = [];

    connect()
    {
        
    }

    handleResponse(event)
    {
        let e;
        if(event.detail[0].success)
        {
            e = new CustomEvent("show-toast", { detail: "Device successfully updated!" });
        }
        else
        {
            e = new CustomEvent('show-toast', { detail: "An error occurred:\n" + event.detail[0].error })
        }

        window.dispatchEvent(e);
    }
}